import { v4 as uuid } from 'uuid';

import { MESSAGES } from '../../../constants';

export interface IPhone {
  readonly id: string;
  readonly type: MESSAGES.PHONE;
  readonly rm: boolean;
  readonly nodeId: string;
  readonly role?: string;
}

export const createPhoneSelector = (data): IPhone => ({
  id: data.id || uuid(),
  type: MESSAGES.PHONE,
  rm: Boolean(data.rm),
  nodeId: data.nodeId,
});
